import uiRouter from '@uirouter/angularjs';
import ngMessages from 'angular-messages';

export const VlnDialogControllerModule = angular
    .module('app.comopnents.modals.vlnDialogController', [
        uiRouter,
        ngMessages,
        'ngMaterial'
    ]).controller('vlnDialogController', ($scope, $mdDialog, $state) => {
        $scope.cancelDialog = result => $mdDialog.cancel(result);
        $scope.closeDialog = result => $mdDialog.hide(result);
        $scope.gtmid = `admin_${$state.current.name}`;
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/modals/dialog.controller.js